import { Profile } from '../models/UserStore';

export const customLog = (
  message: unknown,
  profile: Profile | null | undefined,
) => {
  const includeUserIds: string[] = [
    'e89b86ca-0aa1-4fff-b2dd-8e6a8a4ac7f0',
    'f250c78f-3b67-45cb-afc4-fcb35dda424b',
    '97ac9d38-b7bf-4dc7-b14c-0ab2b111318f',
  ]; // userId in prod that can see console log
  if (
    process.env.NODE_ENV === 'development' ||
    profile?.worksForJoyajoy ||
    includeUserIds.includes(profile?.userId ?? '')
  ) {
    console.log(message);
  }
};
